import type { MessengerBridge } from './types'

export const createBrowserBridge = (): MessengerBridge => ({
  platform: 'browser',

  getInitData() {
    return ''
  },

  getStartParam() {
    return new URLSearchParams(window.location.search).get('start_param')
  },

  getTheme() {
    return window.matchMedia('(prefers-color-scheme: dark)').matches ? 'dark' : 'light'
  },

  ready() {},
  expand() {},
  close() {},
  setBackHandler() {},
})
